import type { SVGProps } from 'react';

/** A fênix da identidade visual do Grupo Fênix (laranja #FD7218). */
export function FenixLogo({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 44"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M34.7186 2.30716H27.439C27.3421 2.30716 27.2661 2.22671 27.2661 2.13226V0.23291H23.9323V2.13226C23.9323 3.78327 25.0562 5.16843 26.5675 5.56369L24.1848 11.3807L1.91708 1.95387L0.201782 6.09887L33.4114 20.1534L35.1267 16.0084L28.2793 13.1086L31.326 5.67213H34.1411C33.2488 6.46615 32.6886 7.63094 32.6886 8.92516V11.2583H36.0224V8.92516C36.0224 8.39348 36.4512 7.95974 36.9768 7.95974H38.6437V6.27376C38.6437 4.08408 36.8835 2.30366 34.7186 2.30366V2.30716Z"
        fill="currentColor"
      />
      <path
        d="M4.35102 11.0355L2.63611 15.1821L30.5837 27.0069L32.2987 22.8603L4.35102 11.0355Z"
        fill="currentColor"
      />
      <path
        d="M4.86005 24.2212L16.836 29.2792L13.976 36.268L18.0775 37.9889L20.9375 31.0141L23.6695 32.1685L19.5922 42.1199L23.6937 43.8549L29.4863 29.7514L6.57188 20.0728L4.86005 24.2212Z"
        fill="currentColor"
      />
    </svg>
  );
}
